import { useAuth } from '@/hooks/use-auth';
import { useLocation } from 'wouter';
import { cn } from '@/lib/utils';
import { removeToken } from '@/lib/token-storage';

/**
 * FloatingRegisterButton - Pulsante floating sempre visibile per guest
 * Posizionato in basso a destra, sopra la navbar
 * Con animazione pulsante ogni tot secondi
 */
export function FloatingRegisterButton() {
  const { isGuest, authState } = useAuth();
  const [, setLocation] = useLocation();

  // Non mostrare se non è guest
  if (!isGuest) {
    return null;
  }

  const handleClick = () => {
    console.log('[FloatingRegisterButton] Click registrazione - logout guest...');

    // IMPORTANTE: Imposta PRIMA il flag, PRIMA di rimuovere il token
    sessionStorage.setItem('want_to_register', 'true');

    // Poi rimuovi token guest
    removeToken();

    // Forza il reload per resettare completamente lo stato auth
    // Il flag want_to_register impedirà l'auto-login guest
    window.location.href = '/register';
  };

  return (
    <div className="fixed bottom-20  right-4 z-50 flex flex-col items-center gap-1">
      <button
        onClick={handleClick}
        className={cn(
          "tg-bg",
          "rounded-full",
          "w-16 h-16",
          "shadow-lg hover:shadow-xl",
          "flex items-center justify-center",
          "p-2",
          "transition-all duration-300",
          "hover:scale-110",
          "overflow-hidden"
        )}
        aria-label="Registrati"
      >
        <img
          src="/assets/images/CAACAgEAAxkBAWEgSWlHKmfYNBTjvpykFodr7ATZ_sLIAAIWAAPfTigZgHVDMdOl.gif"
          alt="Register"
          className="w-full h-full object-cover"
        />
      </button>
      <span className="text-xs text-white font-semibold tracking-wide uppercase">
        Register Now!
      </span>
    </div>
  );
}
